export default __webpack_public_path__ + "static/media/ABH.24cb6483.png";